// extracted by mini-css-extract-plugin
export var banner = "category-image-banner-module--banner--2e866";